export const SESSION_COOLING_CODE = "SESSION_COOLING";

export function isSessionCoolingResponse(status, data) {
  return status === 403 && data?.code === SESSION_COOLING_CODE;
}

export function formatCoolingRemaining(ms) {
  if (!ms || ms <= 0) return "0:00";
  const totalSec = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

export function getCoolingProgress(remainingMs, durationMs) {
  if (!durationMs || durationMs <= 0) return 0;
  return Math.min(1, Math.max(0, remainingMs / durationMs));
}

export function formatDurationLabel(ms) {
  if (!ms || ms <= 0) return "";
  const totalMin = Math.round(ms / 60000);
  if (totalMin < 60) return `${totalMin} minute${totalMin === 1 ? "" : "s"}`;
  const hours = totalMin / 60;
  if (Number.isInteger(hours)) {
    return `${hours} hour${hours === 1 ? "" : "s"}`;
  }
  return `${totalMin} minutes`;
}

export function normalizeSessionCooling(payload) {
  if (!payload || payload.exempt) {
    return {
      active: false,
      exempt: true,
      coolingUntil: null,
      coolingRemainingMs: 0,
      sessionRemainingMs: null,
      consecutiveLimitMs: null,
      coolingDurationMs: null,
      approaching: false,
    };
  }
  return {
    active: Boolean(payload.active),
    exempt: false,
    coolingUntil: payload.coolingUntil || null,
    coolingRemainingMs: Number(payload.coolingRemainingMs) || 0,
    sessionRemainingMs:
      payload.sessionRemainingMs != null ? Number(payload.sessionRemainingMs) : null,
    consecutiveLimitMs:
      payload.consecutiveLimitMs != null ? Number(payload.consecutiveLimitMs) : null,
    coolingDurationMs:
      payload.coolingDurationMs != null ? Number(payload.coolingDurationMs) : null,
    approaching: Boolean(payload.approaching),
  };
}
